module.exports = __webpack_public_path__ + "img/staring_dot.ef01d614.gif";